export default __webpack_public_path__ + "static/media/action_btn_circle_google@3x.c90642c6.png";